import React from "react";
import { useHistory } from "react-router-dom";
import SuccessDialog from "./SuccessDialog";
import { Typography, useTheme } from "@mui/material";
const useStyles = () => {
  const theme = useTheme();
  return {
    dialogbtnStyle: {
      margin: "5px",
      cursor: "pointer",
      fontSize: "14px",
      color: "rgba(0, 0, 0, 0.87)",
      lineHeight: "24px",
      letterSpacing: "1px",
      fontWeight: 600,
    },
    dialogBodytext: {
      textAlign: "justify",
      fontSize: "14px",
      color: theme.textColour.dialogBodytext,
      lineHeight: "22px",
      letterSpacing: "0.5px",
      fontWeight: 400,
    },
  };
};
function LogOutDialog({ setShowLogoutDialog, logout }) {
  const styles = useStyles();
  const navigate = useHistory();
  return (
    <SuccessDialog
      HeaderText={<Typography sx={{}}>Logout ?</Typography>}
      successButton={[
        <Typography
          key={1}
          onClick={() => setShowLogoutDialog(false)}
          sx={styles.dialogbtnStyle}
        >
          Cancel
        </Typography>,
        <Typography
          key={2}
          onClick={async () => {
            await logout();
            setShowLogoutDialog(false);
            navigate.replace("/logout");
          }}
          sx={styles.dialogbtnStyle}
        >
          Logout
        </Typography>,
      ]}
      BodyText={
        <Typography sx={styles.dialogBodytext}>
          Are you sure you want to log out? If you want to login again, you need
          to reenter your email ID and OTP.
        </Typography>
      }
      dismiss={""}
    />
  );
}
export default LogOutDialog;
